import styled from 'styled-components';
import type { GroupRateKind } from '@shared/api';
import { RATE_KIND_LABEL, groupUnitLabel } from '../groups';
import { FleetChip } from './FleetChip';
import { fleetType } from './tokens';

/** Единица учёта группы — нейтральная метка без точки: это не статус. */
const UnitTag = styled.span`
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: ${({ theme }) => `1px ${theme.spacing(2)}`};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.xs};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${fleetType.small};
  font-weight: 500;
  line-height: 1.3;
  white-space: nowrap;
`;

export function GroupUnitChip({ unit }: { unit: string }) {
  return <UnitTag>{groupUnitLabel(unit)}</UnitTag>;
}

/**
 * «Нет ставки» — красным: текст, кромка и подложка. Красный темы мелким
 * текстом AA проходит (в отличие от оранжевого и зелёного), а слово читается
 * и без цвета.
 */
const MissingChip = styled(FleetChip)`
  border-color: ${({ theme }) => theme.colors.status.danger}73;
  background: ${({ theme }) => theme.colors.status.danger}14;
  color: ${({ theme }) => theme.colors.status.danger};
  font-weight: 600;
`;

/** Откуда ставка группы на дату: своя ставка объекта, по умолчанию для холдинга, нет. */
export function RateKindChip({ kind }: { kind: GroupRateKind }) {
  if (kind === 'missing')
    return <MissingChip $tone="danger">{RATE_KIND_LABEL.missing}</MissingChip>;
  return (
    <FleetChip $tone={kind === 'project' ? 'success' : 'info'}>{RATE_KIND_LABEL[kind]}</FleetChip>
  );
}
